var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('aresGPT'),_c('navbar',{attrs:{"title":"Ares - Main menu","home":true,"accolist":true,"type":"main"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }